import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";
import CS from "../../commons/services/Common";
import VS from "../../commons/services/Validation";
import MS from "../../commons/services/Moment";
import FileUpload from "../../commons/components/FileUpload";
import SelectBox from "../../commons/components/SelectBox";
import Date from "../../commons/components/Date";
import DateCustom from "../../commons/components/DateCustom";
import { Notification } from "element-react";
import AddressSearch from "../../commons/components/AddressSearch"; // 2024.04 카카오 주소 검색 API 이용

/**
 * 발전소 등록 컴포넌트
 */
class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: props.match.params.plantId,
      isShow: false,
      modInfos: [],
      invInfos: [],
      structureInfos: [],
      searchAddressInfos: [],
      operationStartDt: "",
      serviceWarrantyDt: "",
      isLoading: true,
      addrxy: { addr: "", x: "", y: "" }, // 2024.04
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setAddrXY = this.setAddrXY.bind(this); // 2024.04
    this.checkAddressValidation = this.checkAddressValidation.bind(this); // 2024.04

    this.fileInfos = {};
    this.item = {
      name: "",
      address: "",
      bizNum: "",
    };
  }

  componentDidMount() {
    this.getItem();
    this.getOptions();
  }

  getBizNum(value, idx) {
    if (typeof value != "undefined" && value !== null) {
      if (value.indexOf("-") > 0) {
        let arr = value.split("-");
        return arr[idx];
      }
    }
    return null;
  }

  async getItem() {
    let res = await axios.get(
      `/usr/api/constructor-plant/detail/${this.state.plantId}`
    );
    let bizNum = res.data.bizNum;
    res.data.bizNum1 = this.getBizNum(bizNum, 0);
    res.data.bizNum2 = this.getBizNum(bizNum, 1);
    res.data.bizNum3 = this.getBizNum(bizNum, 2);
    this.setState({
      item: res.data,
      operationStartDt: res.data.operationStartDt,
      serviceWarrantyDt: res.data.serviceWarrantyDt,
      addrxy: { addr: res.data.address, x: res.data.lngX, y: res.data.latY }, // 2024.04
    });
  }

  async getOptions() {
    let modInfos = await axios.get("/cst/api/mod-inv/MOD");
    modInfos = modInfos.data.map((obj) => {
      return {
        value: obj.id,
        text: obj.corpName,
      };
    });
    let invInfos = await axios.get("/cst/api/mod-inv/INV");
    invInfos = invInfos.data.map((obj) => {
      return {
        text: obj.corpName,
        value: obj.id,
      };
    });
    let structureInfos = await CS.getCodeInfo("STRUCTURE_TYPE");
    structureInfos = structureInfos.map((obj) => {
      return {
        text: obj.codeName,
        value: obj.code,
      };
    });

    this.setState({
      modInfos: modInfos,
      invInfos: invInfos,
      structureInfos: structureInfos,
      isLoading: false,
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const data = new FormData(e.target);

    if (this.state.operationStartDt === "") {
      CS.notification("warning", "운전개시일은 필수 입력값 입니다.");
      return;
    }
    if (this.state.serviceWarrantyDt === "") {
      CS.notification("warning", "서비스보증 기간은 필수 입력값 입니다.");
      return;
    }

    this.item = {
      id: this.state.plantId,
      constructorId: 4,
      name: data.get("name"),
      address: data.get("address"),
      latY: data.get("latY"),
      lngX: data.get("lngX"),
      bizNum: data.get("bizNum"),
      installationCnt: data.get("installationCnt"),
      installationCapacity: data.get("installationCapacity"),
      operationStartDt: this.state.operationStartDt,
      serviceWarrantyDt: this.state.serviceWarrantyDt,
      floorPlanFileInfo: this.fileInfos.floorPlanFile,
      oneLineDiagramFileInfo: this.fileInfos.oneLineDiagramFile,
      serialNoFileInfo: this.fileInfos.serialNoFile,
      unitPrice: data.get("unitPrice"),
      /*
            cstNoticeRate: data.get('cstNoticeRate'),
            usrNoticeRate: data.get('usrNoticeRate'),
            structure: data.get('structure'),
            structureBizName: data.get('structureBizName'),
            structureBizTelNum: data.get('structureBizTelNum'),
            electricWorkBizName: data.get('electricWorkBizName'),
            electricWorkBizTelNum: data.get('electricWorkBizTelNum'),
            */
    };

    let result = await CS.update("/cst/api/constructor-plant", this.item);
  }

  doSetFile = (category, fileInfos) => {
    this.fileInfos[category] = fileInfos;
  };

  handleChange = (e) => {};

  /* 이전 작업 내용 - 시작 - 2024.04 */
  // findAddress = async (value) => {
  //   let infos = await CS.getAddressInfo(CS.$("#address"));
  //   if (infos.length > 0) {
  //     this.setState({
  //       isShow: true,
  //       searchAddressInfos: infos,
  //     });
  //   }
  // };
  /* 이전 작업 내용 - 끝 - 2024.04 */

  checkUser = () => {
    let bizNum =
      CS.$("#bizNum1") + "-" + CS.$("#bizNum2") + "-" + CS.$("#bizNum3");
    document.getElementById("bizNum").value = bizNum;
  };

  clickAddress = (address, latY, lngX) => {
    //console.log(address, latY, lngX)
    document.getElementById("address").value = address;
    document.getElementById("latY").value = latY;
    document.getElementById("lngX").value = lngX;
    this.setState({
      isShow: false,
      searchAddressInfos: [],
    });
  };

  handleDateChange(name, dt) {
    this.setState({
      [name]: dt,
    });
  }

  async handleDeleteFile(name, id, fileId) {
    let result = await CS.delete(`/api/file/${id}/${fileId}`);
    if (result.isSuccess) {
      let item = this.state.item;
      item[name] = null;
      this.setState({
        item: item,
      });
    }
  }

  // 2024.04
  setAddrXY(address, longitude, latitude) {
    this.setState({
      addrxy: { addr: address, x: longitude, y: latitude },
    });
  }

  // 2024.04
  checkAddressValidation(e) {
    alert("주소 검색을 이용해서 발전소 주소를 입력해주세요.");
    e.target.blur();
  }

  render() {
    const {
      isLoading,
      isShow,
      plantId,
      modInfos,
      invInfos,
      structureInfos,
      searchAddressInfos,
      item,
    } = this.state;
    if (isLoading) return <div>Loading...</div>;

    return (
      <>
        <div className="page-tit">
          <div className="container location">
            <h2 className="tit">전체 발전소 리스트</h2>
            <span>
              <strong>대기 발전소 등록</strong>
            </span>
          </div>
        </div>
        <div className="container pt-25">
          <form onSubmit={this.handleSubmit}>
            <input
              type="hidden"
              name="bizNum"
              id="bizNum"
              defaultValue={item.bizNum}
            />
            <input
              type="hidden"
              name="latY"
              id="latY"
              // defaultValue={item.latY} // 2024.04
              value={this.state.addrxy.y} // 2024.04
            />
            <input
              type="hidden"
              name="lngX"
              id="lngX"
              // defaultValue={item.lngX} // 2024.04
              value={this.state.addrxy.x} // 2024.04
            />
            <div className="mb-spacing10">
              <div className="card2 py-15">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">발전소명</label>
                    <input
                      type="text"
                      className="w550"
                      name="name"
                      id="name"
                      defaultValue={item.name}
                      placeholder="발전소명을 입력하세요."
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="card2 py-15 not-hidden">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">발전소 주소</label>
                    <div className="addr-form">
                      <input
                        type="text"
                        className="w550"
                        name="address"
                        id="address"
                        // defaultValue={item.address}
                        placeholder="발전소 주소 검색을 이용하세요."
                        required
                        // onChange={this.findAddress} // 2024.04
                        defaultValue={this.state.addrxy.addr} // 2024.04
                        onFocus={this.checkAddressValidation} // 2024.04
                      />
                      {/* <button type="button" className="btn primary w160 ml-20" onClick={this.findAddress}>주소검색</button> */}{" "}
                      {/* 2024.04 */}
                      <AddressSearch setAddrXY={this.setAddrXY} />{" "}
                      {/* 2024.04 */}
                      <div
                        id="address_area"
                        className={
                          isShow
                            ? "address-layer w550 show"
                            : "address-layer w550"
                        }
                      >
                        {searchAddressInfos.map((row) => (
                          <div
                            key={row.address}
                            className="address-list"
                            onClick={() =>
                              this.clickAddress(
                                row.roadAddress,
                                row.latY,
                                row.lngX
                              )
                            }
                          >
                            <div className="road-num">
                              <span>지번</span>
                              {row.address}
                            </div>
                            <div className="road-name">
                              <span>도로명</span>
                              {row.roadAddress}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card2 py-15">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">사업자 번호</label>
                    <input
                      type="text"
                      className="w120 center"
                      name="bizNum1"
                      id="bizNum1"
                      defaultValue={item.bizNum1}
                      maxLength="3"
                      required
                    />{" "}
                    -
                    <input
                      type="text"
                      className="w120 center ml-15"
                      name="bizNum2"
                      id="bizNum2"
                      defaultValue={item.bizNum2}
                      maxLength="3"
                      required
                    />{" "}
                    -
                    <input
                      type="text"
                      className="w260 center ml-15"
                      name="bizNum3"
                      id="bizNum3"
                      defaultValue={item.bizNum3}
                      maxLength="5"
                      required
                    />
                    <button
                      type="button"
                      className="btn primary w160 ml-20"
                      onClick={this.checkUser}
                    >
                      사용자연결
                    </button>
                  </div>
                </div>
              </div>
              <div className="card2 py-15">
                <div className="form-inline3 inline2">
                  <div className="form-group">
                    <label className="tit w110">설비 용량</label>
                    <span className="floting">
                      <input
                        type="text"
                        className="w100"
                        name="installationCapacity"
                        defaultValue={item.installationCapacity}
                        onChange={(e) => {
                          VS.onInput("number", e);
                        }}
                      />
                      <small className="unit right">kW</small>
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="tit">설치 장수</label>
                    <span className="floting">
                      <input
                        type="text"
                        className="w100"
                        name="installationCnt"
                        defaultValue={item.installationCnt}
                        onChange={(e) => {
                          VS.onInput("number", e);
                        }}
                      />
                      <small className="unit right">장</small>
                    </span>
                  </div>
                </div>
              </div>
              {/*
                            <div className="card2 py-15">
                                <div className="form-inline3 inline2">
                                    <div className="form-group">
                                        <label className="tit w110">태양광모듈 제조사</label>
                                        <SelectBox className="w115" name="moduleCompanyId" id="moduleCompanyId" value={item.moduleCompanyId} default="선택" items={modInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w90">모듈 모델명</label>
                                        <input type="text" className="w110" name="moduleModelName" defaultValue={item.moduleModelName}  />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit">설치 장수</label>
                                        <span className="floting">
                                            <input
                                                type="text" className="w80" name="installationCnt" defaultValue={item.installationCnt}
                                                onChange={(e) => {VS.onInput('number', e)}}
                                            />
                                            <small className="unit right">장</small>
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit">설치 용량</label>
                                        <span className="floting">
                                            <input
                                                type="text" className="w80" name="installationCapacity" defaultValue={item.installationCapacity}
                                                onChange={(e) => {VS.onInput('number', e)}}
                                            />
                                            <small className="unit right">kW</small>
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w110">인버터 제조사</label>
                                        <SelectBox
                                            className="w115" name="inverterCompanyId" default="선택" value={item.inverterCompanyId}
                                            items={invInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label className="tit w90">인버터 모델명</label>
                                        <input type="text" className="w110" name="inverterModelName" defaultValue={item.inverterModelName} />
                                    </div>
                                </div>
                            </div>
                            */}
              <div className="card2 py-15">
                <div className="form-inline3">
                  <div className="form-group">
                    <label className="tit w110">도면 배치도</label>
                    {item.floorPlanFileId == null ? (
                      <>
                        <FileUpload
                          className="w550"
                          handleUploadFile={this.doSetFile}
                          category="floorPlanFile"
                          accept="image/*"
                        />
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn white wp50"
                          onClick={() => CS.fileDown(item.floorPlanFileId)}
                        >
                          도면 파일
                        </button>
                        <button
                          type="button"
                          className="btn red w80 ml-20"
                          onClick={() =>
                            this.handleDeleteFile(
                              "floorPlanFileId",
                              item.floorPlanFileId,
                              item.floorPlanFile.id
                            )
                          }
                        >
                          파일삭제
                        </button>
                      </>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="tit w110">단선결선도</label>
                    {item.oneLineDiagramFileId === null ? (
                      <>
                        <FileUpload
                          className="w550"
                          handleUploadFile={this.doSetFile}
                          category="oneLineDiagramFile"
                          accept="image/*"
                        />
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn white wp50"
                          onClick={() => CS.fileDown(item.oneLineDiagramFileId)}
                        >
                          단선결선도 파일
                        </button>
                        <button
                          type="button"
                          className="btn red w80 ml-20"
                          onClick={() =>
                            this.handleDeleteFile(
                              "oneLineDiagramFileId",
                              item.oneLineDiagramFileId,
                              item.oneLineDiagramFile.id
                            )
                          }
                        >
                          파일삭제
                        </button>
                      </>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="tit w110">
                      모듈 인버터
                      <br />
                      시리얼 넘버
                    </label>
                    {item.serialNoFileId == null ? (
                      <>
                        <FileUpload
                          className="w550"
                          handleUploadFile={this.doSetFile}
                          category="serialNoFile"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                        <Link
                          to="/files/시리얼번호 양식파일.xlsx"
                          target="_blank"
                          download
                        >
                          <button
                            type="button"
                            className="btn primary w160 ml-20"
                          >
                            양식 파일(*.xlsx)
                          </button>
                        </Link>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn white wp50"
                          onClick={() => CS.fileDown(item.serialNoFileId)}
                        >
                          모듈 인버터 시리얼번호 엑셀파일
                        </button>
                        <button
                          type="button"
                          className="btn red w80 ml-20"
                          onClick={() =>
                            this.handleDeleteFile(
                              "serialNoFileId",
                              item.serialNoFileId,
                              item.serialNoFile.id
                            )
                          }
                        >
                          파일삭제
                        </button>
                      </>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="tit w110">운전 개시일</label>
                    <Date
                      name="operationStartDt"
                      value={item.operationStartDt}
                      handleDateChange={this.handleDateChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="tit w110">서비스 보증 기간</label>
                    <DateCustom
                      name="serviceWarrantyDt"
                      value={item.serviceWarrantyDt}
                      handleDateChange={this.handleDateChange}
                    />
                  </div>
                </div>
              </div>
              <div className="card2 py-15">
                <div className="form-inline3 inline2">
                  <div className="form-group">
                    <label className="tit w110">SMP + REC 가격</label>
                    1kW당
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="w220"
                      name="unitPrice"
                      defaultValue={item.unitPrice}
                      onChange={(e) => {
                        VS.onInput("number", e);
                      }}
                    />
                    <label className="tit ml-10">원</label>
                  </div>
                </div>
              </div>
              {/*
                            <div class="card2 py-15">
                                <h3 class="content-tit1 mt-10 pl-0">외주용역정보</h3>
                                <div class="form-inline3 inline2">
                                    <div class="form-group">
                                        <label class="tit w100">기초(토목)공사</label>
                                        <select class="w120">
                                            <option value="">선택</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w80 text-right">외주업체명</label>
                                        <input type="text" class="w130" />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w50 text-right">연락처</label>
                                        <input type="text" class="w240" />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w100">구조물공사</label>
                                        <SelectBox className="w120" name="structure" id="structure" value={item.structure} items={structureInfos} handleSelectChange={this.handleChange} />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w80 text-right">외주업체명</label>
                                        <input type="text" className="w130" name="structureBizName" defaultValue={item.structureBizName} />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w50 text-right">연락처</label>
                                        <input
                                            type="text" className="w240" name="structureBizTelNum"
                                            defaultValue={item.structureBizTelNum} maxLength="13"
                                            onChange={(e) => {VS.onInput('phone', e)}} />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w100">전기공사</label>
                                        <select class="w120">
                                            <option value="">선택</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w80 text-right">외주업체명</label>
                                        <input type="text" className="w130" name="electricWorkBizName" defaultValue={item.electricWorkBizName} />
                                    </div>
                                    <div class="form-group">
                                        <label class="tit w50 text-right">연락처</label>
                                        <input
                                            type="text" className="w240" name="electricWorkBizTelNum"
                                            defaultValue={item.electricWorkBizTelNum} maxLength="13"
                                            onChange={(e) => {VS.onInput('phone', e)}} />
                                    </div>
                                </div>
                            </div>
                            */}
            </div>
            {/*
                        <div className="card px-12 py-25 mt-15">
                            <div className="card-title">모듈 비정상 작동 알림 설정</div>
                            <div className="flex center">
                                <div className="form-inline">
                                    <div className="form-group">
                                        <label className="tit size15">시공사 알림</label>
                                        <div className="size15 bold">
                                            모듈이
                                            <span className="mx-15">
                                                <input
                                                    type="text" className="w50 h40 style1" name="cstNoticeRate" defaultValue={item.cstNoticeRate}
                                                    onChange={(e) => {VS.onInput('number', e)}}
                                                />%
                                            </span>
                                            이상 비정상 작동일때 알림 설정
                                        </div>
                                    </div>
                                    <div className="form-group ml-70">
                                        <label className="tit size15">사용자 알림</label>
                                        <div className="size15 bold">
                                            모듈이
                                            <span className="mx-15">
                                                <input
                                                    type="text" className="w50 h40 style1" name="usrNoticeRate" defaultValue={item.usrNoticeRate}
                                                    onChange={(e) => {VS.onInput('number', e)}}
                                                />%
                                            </span>
                                            이상 비정상 작동일때 알림 설정
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        */}
            <div className="card yellow text-center mt-15 pa-15">
              <strong className="size15 mr-20">
                모듈 배치와 장비 및 통신정보를 등록해주세요.
              </strong>
              <Link
                to={
                  plantId == 109
                    ? `/plant-list/drawing-v2/${plantId}`
                    : `/plant-list/drawing/${plantId}`
                }
                className="btn secondary2 w300 size15 mr-10 radius15"
              >
                모듈 시리얼 넘버 배치 수정
              </Link>
              <Link
                to={`/plant-list/equip/${plantId}`}
                className="btn secondary2 w300 size15 radius15"
              >
                장비 및 통신 정보
              </Link>
            </div>
            {/* <div className="btn-areaC1 pb-50">
              <button type="submit" className="btn">
                임시저장
              </button>
              <button type="button" className="btn primary" disabled>
                등록완료
              </button>
            </div> */}
            <div className="btn-areaC2">
              <button type="submit" className="btn primary">
                저장
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default Create;
